import { render, staticRenderFns } from "./clinical-trial-filter-app.vue?vue&type=template&id=1998b358&"
import script from "./clinical-trial-filter-app.vue?vue&type=script&lang=js&"
export * from "./clinical-trial-filter-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports